import { useContext, useEffect, useState } from "react";
import MapContext from "../Map/MapContext";
import OLVectorLayer from "ol/layer/Vector";
import styleCinemas from '../Styles/styleCinemas'
import cinemas from '../Source/Cinemas'

const Cinemas = ({ zIndex = 0 }) => {

	const { map } = useContext(MapContext);
	const [couche, setCouche] = useState(null);
	useEffect(() => {

		if (!map) return;

		async function anyNameFunction() {
			let vectorLayer = new OLVectorLayer({
				source: await cinemas(),
				style: styleCinemas,
				type:'CINEMA'
			});
			setCouche(vectorLayer)

			map.addLayer(vectorLayer);
			vectorLayer.setZIndex(zIndex);
		}    // Execute the created function directly
		anyNameFunction();
		return () => {
			if (map) {
				map.removeLayer(couche);
			}
		};
		// eslint-disable-next-line
	}, [map]);
	return null;
};

export default Cinemas;